import React from "react";
import '../styles/about.css';
//import logo from "../assets/imgs/logo.png";
import iso from "../assets/imgs/colivri-iso.png";
import { useTranslation } from 'react-i18next';

function Navbar() {

    const { t } = useTranslation('home');

    return (
        <div className="about">
            <h2>{t('about-us')}</h2>

            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-lg-6 d-flex justify-content-center">
                        <img src={iso} alt="iso"></img>
                    </div>
                    <div className="col-sm-12 col-lg-6 info">
                        <p>{t('about-us-1')}</p>
                        <p>{t('about-us-2')}</p>
                        <p>{t('about-us-3')}</p>
                    </div>
                </div>

            </div>

            
        </div>
    );
}

export default Navbar;





